export default "__VITE_ASSET__CueXVj5t__"